import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AmeritradePotentialTradesQuoteResponse } from "../Models/AmeritradePotentialTradesQuoteResponse";
import { AmeritradeOptionQuoteResponse } from "../Models/AmeritradeSymbolOptionsQuotesResponse";
import { AmeritradeSymbolQuotesResponse } from "../Models/AmeritradeSymbolQuotesResponse";

@Injectable({
  providedIn: "root",
})
export class ApiRestService {
  public restUrl: string;

  constructor(private http: HttpClient) {}

  getRestUrl() {
    return this.http.get("/api/getresturl/");
  }

  getOptions(symbol: string) {
    return this.http.get<AmeritradeOptionQuoteResponse[]>(
      this.getBaseURL() + "getoptions/" + symbol
    );
  }

  getBaseURL(): string {

    return "https://binter.tradinghosting.com/api/";
    var protocol = window.location.hostname == "localhost" ? "http:" : window.location.protocol;

    return protocol + "//" + window.location.hostname + ":5003/api/"
  }

  getStocks() {
    return this.http.get<AmeritradeSymbolQuotesResponse[]>(
      this.getBaseURL() + "getstocks"
    );
  }

  getTrades(symbol: string) {
    return this.http.get<AmeritradePotentialTradesQuoteResponse[]>(
      this.getBaseURL() + "gettrades/" + symbol
    );
  }
}
function delay(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
